module.exports = false;



//////////////////
// WEBPACK FOOTER
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/~/core-js/modules/_library.js
// module id = ../../../../core-js/modules/_library.js
// module chunks = 5